import GoogleMapReact from "google-map-react";
import React from "react";
const GOOGLE_API = "AIzaSyAw3sGsJ4OzYFgvH2zr0eU-LL0XfgHNC_Q";

const onGoogleApiLoaded = (map, maps) => {
  var triangleCoords = [
    { lat: 37.769603, lng: -122.426438 },
    { lat: 37.76275, lng: -122.435171 },
    { lat: 37.769043, lng: -122.435804 },
    { lat: 37.769603, lng: -122.426438 }
  ];

  // Construct the polygon.
  var bermudaTriangle = new maps.Polygon({
    paths: triangleCoords,
    strokeColor: "#8F5EA1",
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: "#6D74C5",
    fillOpacity: 0.35
  });
  bermudaTriangle.setMap(map);
};

const Map = () => {
  return (
    <div style={{ height: "400px", width: "400px" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: GOOGLE_API }}
        defaultCenter={{ lat: 37.76649, lng: -122.430418 }}
        defaultZoom={15.5}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) => onGoogleApiLoaded(map, maps)}
      ></GoogleMapReact>
    </div>
  );
};
export default Map;
